import DateConstants from 'constants/DateConstants';
import PropTypes from 'prop-types';
import ReactWidgets from 'react-widgets';

export { DateTimePicker } from 'react-widgets';

function pad(n: number, width: number, padding: string = '0') {
  const stringN = String(n);
  return stringN.length >= width
    ? stringN
    : new Array(width - stringN.length + 1).join(padding) + stringN;
}

function getDateTokenValues(date: Date): {[key: string]: string} {
  const m = date.getMonth();
  const d = date.getDate();
  const w = date.getDay();
  const y = date.getFullYear();
  const hours = date.getHours();
  const mins = date.getMinutes();
  const secs = date.getSeconds();
  return {
    MMMM: DateConstants.MONTHS[m],
    M: String(m + 1),
    d: String(d),
    dd: pad(d, 2),
    dddd: DateConstants.WEEKDAYS[w],
    yyyy: String(y),
    h: String(hours % 12 || 12),
    mm: pad(mins, 2),
    ss: pad(secs, 2),
    tt: hours >= 12 ? 'PM' : 'AM',
  };
}

function endOfDecade(time: Date | number) {
  const date = new Date(time);
  date.setFullYear(date.getFullYear() + 10);
  date.setMilliseconds(date.getMilliseconds() - 1);
  return date;
}

function endOfCentury(time: Date | number) {
  const date = new Date(time);
  date.setFullYear(date.getFullYear() + 100);
  date.setMilliseconds(date.getMilliseconds() - 1);
  return date;
}

// @ts-ignore
ReactWidgets.setDateLocalizer({
  // FIXME: This needs to actually use localization data
  formats: {
    default: 'M/d/yyyy h:mm tt',
    date: 'M/d/yyyy',
    time: 'h:mm tt',
    header: 'MMMM yyyy',
    footer: 'dddd, MMMM d yyyy',
    dayOfMonth: 'dd',
    month: 'MMM',
    weekday: 'dddd',
    year: 'yyyy',
    decade(date: Date, culture: string, localizer: { format: (d: Date, y: string, c: string) => string, formats: { year: string } }) {
      return (
        localizer.format(date, localizer.formats.year, culture) +
        ' - ' +
        localizer.format(endOfDecade(date), localizer.formats.year, culture)
      );
    },
    century(date: Date, culture: string, localizer: { format: (d: Date, y: string, c: string) => string, formats: { year: string } }) {
      return (
        localizer.format(date, localizer.formats.year, culture) +
        ' - ' +
        localizer.format(endOfCentury(date), localizer.formats.year, culture)
      );
    },
  },

  propType: PropTypes.oneOfType([PropTypes.string, PropTypes.object, PropTypes.func]),

  firstOfWeek(/* culture */) {
    // FIXME: This needs to actually use localization data
    return 0;
  },

  parse(value: string /* , format, culture */) {
    const date = new Date();
    const time = value.match(/(\d+)(?::(\d\d))?\s*(p?)/i);
    if (time !== null) {
      let hours = parseInt(time[1], 10);
      if (hours === 12 && !time[3]) {
        hours = 0;
      } else if (hours < 12 && time[3]) {
        hours += 12;
      }
      date.setHours(hours);
      date.setMinutes(parseInt(time[2], 10) || 0);
    }
    return date;
  },

  format(value: Date, format: ((val: Date) => string) | string /* , culture */) {
    const tokens = getDateTokenValues(value);
    if (typeof format === 'function') {
      return format(value);
    }
    return format.replace(/(.)\1*/g, token => tokens[token] || token);
  },
});

export default ReactWidgets;
